module.exports = __webpack_public_path__ + "img/block_2.ecede0dd.webp";